module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna11yrs-2@3x.ver2_0_2.jpg?98c942f4";